// extracted by mini-css-extract-plugin
export var bodyOpen = "FullscreenDialog-module--bodyOpen--db6b0";
export var modal = "FullscreenDialog-module--modal--0ac93";
export var overlay = "FullscreenDialog-module--overlay--b94f3";